(function () {
  'use strict';

  angular
    .module('web2print.landing')
    .directive('parcelSelector', parcelSelector);

  /* @ngInject */
  function parcelSelector () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/landing/parcel-selector/parcel-selector.directive.html',
      scope: {
        selectedType: '=',
        parcelTypes: '='
      },
      link: linkFunc,
      controller: ParcelSelectorController,
      controllerAs: 'parcelSelector',
      bindToController: true
    };

    return directive;

    function linkFunc (scope, el, attr, ctrl) {
      el.addClass('parcel-selector');

      const vm = scope.parcelSelector;

      vm.isUsingScroll = isUsingScroll;
      vm.scrollToItemWithIndex = scrollToItemWithIndex;
      vm.getNumVisibleParcels = getNumVisibleParcels;

      scope.$watch('parcelSelector.parcelTypes', scope.parcelSelector.activate);

      /////////////////////////

      function isUsingScroll () {
        const parcelsWrapper = el[0].getElementsByClassName('parcel-selector__parcels-wrapper')[0];
        const overflowX = window.getComputedStyle(parcelsWrapper).overflowX;
        return overflowX === 'scroll';
      }

      function scrollToItemWithIndex (index, parcelWidth) {
        const parcelsWrapper = el[0].getElementsByClassName('parcel-selector__parcels-wrapper')[0];
        const width = parcelsWrapper.offsetWidth;
        parcelsWrapper.scrollLeft = index * parcelWidth - ((width / 2) - (parcelWidth / 2));
      }

      function getNumVisibleParcels (parcelWidth, paddingOffset) {
        const parcelsWrapper = el[0].getElementsByClassName('parcel-selector__parcels-wrapper')[0];
        const width = parcelsWrapper.offsetWidth;
        return width / (parcelWidth + paddingOffset);
      }
    }
  }

  ParcelSelectorController.$inject = ['$log', 'ParcelTypes'];

  /* @ngInject */
  function ParcelSelectorController ($log, ParcelTypes) {
    const vm = this;

    const PARCEL_WIDTH = 207;
    const PADDING_OFFSET = 10;

    vm.offset = 0;
    vm.numVisibleParcels = 0;

    vm.moveLeft = moveLeft;
    vm.moveRight = moveRight;
    vm.moveLeftMobile = moveLeftMobile;
    vm.moveRightMobile = moveRightMobile;
    vm.isFurthestLeft = isFurthestLeft;
    vm.isFurthestRight = isFurthestRight;
    vm.selectParcelType = selectParcelType;

    vm.activate = activate;

    ///////////////////////////////

    function activate () {
      if (vm.parcelTypes && vm.parcelTypes.length > 0) {
        vm.numVisibleParcels = vm.getNumVisibleParcels(PARCEL_WIDTH, PADDING_OFFSET);
        if (!vm.selectedType) {
          if (vm.parcelTypes.length === 1) {
            vm.selectedType = vm.parcelTypes[0];
          } else {
            vm.selectedType = vm.parcelTypes[1];
          }
        } else {
          const tmp = angular.copy(vm.selectedType);
          vm.selectedType = _.find(vm.parcelTypes, { name: tmp.name });

          _.each(vm.selectedType.additionalServices, function (service) {
            const tmpService = _.find(tmp.additionalServices, function (_service) {
              return compareAdditionalServices(_service, service);
            });
            service.selected = tmpService && tmpService.selected;
          });
        }

        const selectedParcelIndex = _.map(vm.parcelTypes, 'name').indexOf(vm.selectedType.name);
        const isUsingScroll = vm.isUsingScroll();

        if (isUsingScroll) {
          vm.scrollToItemWithIndex(selectedParcelIndex, PARCEL_WIDTH);
        } else if (selectedParcelIndex >= vm.numVisibleParcels) {
          // (Num parcels to offset slider + Num parcels to center selected) * Parcel width - half of offset to center
          // selected parcel
          const offset = -((selectedParcelIndex - vm.numVisibleParcels + Math.ceil(vm.numVisibleParcels / 2))
            * (PARCEL_WIDTH) - PADDING_OFFSET / 2);
          setOffset(offset);
        }
      }
    }

    function moveLeft () {
      setOffset(vm.numVisibleParcels * PARCEL_WIDTH - (PARCEL_WIDTH + PADDING_OFFSET / 2));
    }

    function moveRight () {
      setOffset(- vm.numVisibleParcels * (PARCEL_WIDTH) + (PARCEL_WIDTH + PADDING_OFFSET / 2));
    }
    function moveLeftMobile () {
      sideScroll('left', 3, PARCEL_WIDTH, 10);
    }
    function moveRightMobile () {
      sideScroll('right', 3, PARCEL_WIDTH, 10);
    }
    function sideScroll (direction, speed, distance, step) {
      const element = document.getElementById('parcelSelector');
      let scrollAmount = 0;
      const slideTimer = setInterval(function () {
        if (direction === 'left') {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    }

    function isFurthestLeft () {
      return vm.offset === 0;
    }

    function isFurthestRight () {
      return vm.offset === (vm.parcelTypes ? ((vm.parcelTypes.length - vm.numVisibleParcels)
        * -PARCEL_WIDTH + PADDING_OFFSET) : 0);
    }

    function setOffset (delta) {
      let res = vm.offset + delta;
      const minOffset = vm.parcelTypes ? (vm.parcelTypes.length - vm.numVisibleParcels)
        * -PARCEL_WIDTH + PADDING_OFFSET : 0;
      res = Math.max(res, minOffset);
      res = Math.min(res, 0);
      vm.offset = res;
    }

    function selectParcelType (parcelType) {
      vm.selectedType = angular.copy(parcelType);
    }

    function compareAdditionalServices (service1, service2) {
      const isSameService = service1.additionalServiceId === service2.additionalServiceId;
      const hasSameType = !service1.type || !service2.type || (service1.type === service2.type)
        || (service1.type.name === service2.type.name && service1.type.value === service2.type.value);
      return isSameService && hasSameType;
    }
  }
})();
